export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}survey/survey-group`;
    const url = `${baseUrl}/:id`;

    return $resource(url, null, {
        getSurveyGroups: {
            method: 'POST',
            url: `${url}/survey-groups`,
            isArray: true
        },
        update: {
            method: 'PUT',
            url
        },
        notify: {
            method: 'POST',
            url: `${url}/notify`
        },
        addParticipants: {
            method: 'POST',
            url: `${url}/add-participants`,
            isArray: true
        },
        removeParticipants: {
            method: 'POST',
            url: `${url}/remove-participants`,
            isArray: true
        },
        publicView: {
            method: 'GET',
            url: `${baseUrl}/public-view`
        },
        occurrenceTrainings: {
            method: 'GET',
            url: `${baseUrl}/occurrence-trainings`,
            isArray: true
        },
        report: {
            method: 'POST',
            url: `${baseUrl}/report/:guid`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/SurveyGroup/index.js